import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/videoShadow.svg';

export const IconVideoShadow = createIconComponent(Icon);
